import React from "react";
import { FormControlLabel, Checkbox, Typography, FormGroup, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useTranslatedValue from "../../../../hooks/useTranslatedValue";
import useAnswerQuestion from "../../hooks/useAnswerQuestion";
import useQuestionStyles from "./questionStyles";

const CheckboxQuestion = ({ question, isDisabled, followUpUUID }) => {
    const classes = useQuestionStyles();
    const getTranslatedValue = useTranslatedValue();
    const answerQuestion = useAnswerQuestion();
    const checkedValues = Array.isArray(question.value) ? question.value : [];

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));

    const handleChange = (optionId) => (event) => {
        const newValues = event.target.checked ? [...checkedValues, optionId] : checkedValues.filter((id) => id !== optionId);
        answerQuestion(newValues, question, followUpUUID);
    };
    return (
        <>
            <Typography variant="body1" className={classes.questionText} style={{ marginBottom: 8 }}>
                {question.mandatory && <span className={classes.mandatory}>*</span>}
                {getTranslatedValue(question.questionText)}
            </Typography>
            {getTranslatedValue(question.tooltip) && (
                <Typography variant="caption" className={classes.tooltip}>
                    {getTranslatedValue(question.tooltip)}
                </Typography>
            )}
            <FormGroup row={!isXs}>
                {question.props?.allowedValues?.map((option) => (
                    <FormControlLabel
                        key={option.id}
                        control={
                            <Checkbox
                                checked={checkedValues.includes(option.id)}
                                onChange={handleChange(option.id)}
                                name={option.id}
                                color="primary"
                                disabled={isDisabled || question.isDisabled}
                                size="small"
                                style={{ padding: 4 }}
                            />
                        }
                        label={<span style={{ fontSize: 13 }}>{getTranslatedValue(option)}</span>}
                        style={{ marginBottom: 0, marginTop: 0, marginLeft: 0, marginRight: 12 }}
                    />
                ))}
            </FormGroup>
        </>
    );
};

export default CheckboxQuestion;
